// extracted by mini-css-extract-plugin
export default {"speedSection":"SpeedSettingsSection_speedSection__LMZR7","speedSelector":"SpeedSettingsSection_speedSelector__crWcz"};